import * as React from 'react';

function SvgZippayColour(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 56 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="ZippayColour_svg__a"
        maskUnits="userSpaceOnUse"
        x={14}
        y={7}
        width={11}
        height={8}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M14.623 7.894H24.84v6.23H14.624v-6.23z"
          fill="#fff"
        />
      </mask>
      <g mask="url(#ZippayColour_svg__a)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.113 11.59L21.8 13.598h-5.727c-.534-.001-1.05.187-1.45.528l2.888-2.507.044-.038 3.619-3.143a2.257 2.257 0 012.148-.44 2.148 2.148 0 011.47 1.576 2.074 2.074 0 01-.68 2.015v.003z"
          fill="#F15B41"
        />
      </g>
      <mask
        id="ZippayColour_svg__b"
        maskUnits="userSpaceOnUse"
        x={13}
        y={7}
        width={6}
        height={6}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.877 7.896h4.394v4.239h-4.394V7.896z"
          fill="#fff"
        />
      </mask>
      <g mask="url(#ZippayColour_svg__b)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.074 7.896c1.214 0 2.197.95 2.197 2.12 0 1.17-.983 2.119-2.197 2.119-1.213 0-2.197-.95-2.197-2.12 0-1.17.984-2.119 2.197-2.119z"
          fill="#F99D1D"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.074 13.597c-.534-.001-1.05.187-1.45.528l-.019.016a2.067 2.067 0 00-.164 2.992c.811.87 2.2.941 3.102.159l4.258-3.695h-5.727z"
        fill="#272560"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.797 13.598l-4.258 3.695c-.403.35-.927.542-1.47.54h6.57c1.268-.019 2.163-.938 2.163-2.118s-.963-2.1-2.162-2.119l-.843.002z"
        fill="#00B6BD"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.928 16.063a.646.646 0 01-.484-.191.656.656 0 01-.183-.475c-.002-.176.044-.35.131-.505.078-.138.172-.267.281-.383l2.712-2.955h-2.364c-.229 0-.393-.076-.483-.226a.937.937 0 01-.126-.495.752.752 0 01.142-.469.5.5 0 01.423-.195h4.177a.66.66 0 01.476.172c.119.114.179.276.179.482a.978.978 0 01-.101.463 1.577 1.577 0 01-.256.347l-2.824 3.044h2.676a.513.513 0 01.413.19.729.729 0 01.15.475.922.922 0 01-.128.508c-.091.141-.254.213-.482.213h-4.329zM34.489 9.702c-.29 0-.527-.081-.707-.243a.846.846 0 01-.273-.656.85.85 0 01.272-.645c.178-.169.416-.255.708-.255.24 0 .474.077.665.217.209.148.315.379.315.685 0 .273-.092.494-.273.657-.182.163-.42.242-.707.242v-.002zm0 6.438c-.743 0-.898-.367-.898-.676v-4.501c0-.235.073-.426.22-.566.145-.14.378-.212.69-.212.265 0 .474.058.622.173.149.115.232.3.232.538v4.544c0 .248-.081.43-.24.541-.16.112-.365.16-.626.16zM39.429 11.42a1.148 1.148 0 00-.55.124c-.159.087-.295.208-.398.354a1.65 1.65 0 00-.25.54 2.652 2.652 0 00-.085.687c0 .527.112.95.337 1.257.224.306.53.45.948.45.419 0 .724-.154.935-.47.212-.317.325-.738.325-1.237 0-.23-.029-.46-.088-.684a1.725 1.725 0 00-.245-.541 1.13 1.13 0 00-.392-.352 1.122 1.122 0 00-.537-.129zm-2.137 6.445c-.695 0-.842-.374-.842-.687V10.81a.71.71 0 01.22-.533c.145-.14.378-.212.692-.212a1.26 1.26 0 01.561.126c.185.091.28.27.28.527a2.085 2.085 0 01.514-.43c.348-.208.751-.317 1.16-.31.394-.008.783.073 1.137.236.324.154.607.38.825.658.227.298.393.634.488.992.11.404.163.82.16 1.239.004.425-.058.849-.184 1.257a2.92 2.92 0 01-.535.998c-.234.28-.53.504-.868.657a2.788 2.788 0 01-1.17.236c-.27.008-.54-.029-.797-.108a2.236 2.236 0 01-.523-.25 1.433 1.433 0 01-.241-.198v1.45c0 .252-.071.438-.212.553-.141.115-.358.167-.665.167z"
        fill="#272560"
      />
    </svg>
  );
}

export default SvgZippayColour;
